import {
  QuoteNoSupplierAssignedResponse,
  QuoteProcurementPartInfoResponse
} from '@/main/models/response';

export enum CartTypes {
  ADD_CART = '@cart/ADD_CART',
  ADDING_CART = '@cart/ADDING_CART',
  UPDATE_CART = '@cart/UPDATE_CART',
  UPDATING_CART = '@cart/UPDATING_CART',
  SAVE_CART = '@cart/SAVE_CART',
  REMOVE_CART = '@cart/REMOVE_CART',
  REMOVING_CART = '@cart/REMOVING_CART',
  LOAD_CART = '@cart/GET_CART',
  ERROR_CART = '@cart/ERROR_CART',
  RESET_REDUCER_CART = '@cart/RESET_REDUCER_CART',
  CLEAR_ALL_CART = '@cart/CLEAR_ALL_CART',
  SET_ERRORS_GENERAL_CART = '@cart/SET_ERRORS_GENERAL_CART'
}

export interface CartPart {
  id: string;
  guid?: string;
  guidSupplierInventoryWarehouse: string;
  guidSupplierInventory: string;
  guidQuoteSupplierItem: string;
  guidPart: string;
  partName: string;
  idPartType: number;
  image?: string;
  stock?: number;
  partType: string;
  quantity: number;
  shippingCost: number;
  deliveryDeadline: number;
  price: number;
  priceFormatted: string;
  priceCap: number;
  priceCapFormatted: string;
  priceTotalFormatted: string;
  priceDiffPercent: number;
  totalPrice: number;
  currency: string;
  externalPartId: string;
  partBrand: string;
  deliveryBySupplier?: boolean;
  guidQuoteItem: string;
  quoteProcurementPartInfo: QuoteProcurementPartInfoResponse;
  systemReferencePrice?: number;
  systemReferencePriceFormatted?: string;
}

export interface QuotationShipingCompanyItems {
  errorMessage: string;
  shippingCompany: string;
  serviceName: string;
  deliveryDays: string;
}

export interface ShipingCompany {
  errorMessage?: string;
  quotationShipingCompanyItems: QuotationShipingCompanyItems[];
}

export interface Cart {
  id: string;
  guid: string;
  guidQuote: string;
  rating?: number;
  guidSupplierInventoryWarehouse?: string;
  guidSupplierInventory?: string;
  name: string;
  isFavoriteSupplier: boolean;
  deliveryBySupplier: boolean;
  deliveryDaysSupplier: number | null;
  totalShippingCost: number;
  totalPartsPrice: number;
  totalParts: number;
  parts: CartPart[];
  shipingCompany: ShipingCompany | undefined;
  shipingIntegrationIsUnavailable: boolean;
}

export interface CartState {
  readonly cartItems: {
    data: Cart[];
    dataNoSupplierAssigned: QuoteNoSupplierAssignedResponse | null;
    dataUnansweredItems: QuoteNoSupplierAssignedResponse | null;
    dataUnansweredCanceledItems: QuoteNoSupplierAssignedResponse | null;
    dataUnansweredRequotedItems: QuoteNoSupplierAssignedResponse | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
    isLoadingUpdate: boolean;
    idPartIsLoading: string | null;
  };
  readonly summary: {
    total: number;
    shippingCost: number;
    totalParts: number;
  };
  readonly errorMessagesGeneral: string[] | null;
}

export interface AddCart {
  type: typeof CartTypes.ADD_CART;
  payload: {
    data: Cart;
  };
}
export interface AddingCart {
  type: typeof CartTypes.ADDING_CART;
  payload: {
    data: Cart;
    guidQuoteSupplierItem: string | null;
  };
}
export interface UpdateCart {
  type: typeof CartTypes.UPDATE_CART;
  payload: {
    data: CartPart;
    guidSupplier: string;
  };
}
export interface UpdatingCart {
  type: typeof CartTypes.UPDATING_CART;
  payload: {
    data: CartPart;
    guidSupplier: string;
    guidQuoteSupplierItem: string | null;
  };
}
export interface SaveCart {
  type: typeof CartTypes.SAVE_CART;
  payload: {
    data: Cart[];
    dataNoSupplierAssigned: QuoteNoSupplierAssignedResponse | null;
    dataUnansweredItems: QuoteNoSupplierAssignedResponse | null;
    dataUnansweredCanceledItems: QuoteNoSupplierAssignedResponse | null;
    dataUnansweredRequotedItems: QuoteNoSupplierAssignedResponse | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface RemoveCart {
  type: typeof CartTypes.REMOVE_CART;
  payload: {
    guidQuoteSupplierItem: string;
    idPart: string;
    isError: boolean;
    errorMessages: string[] | null;
  };
}
export interface RemovingCart {
  type: typeof CartTypes.REMOVING_CART;
  payload: {
    guidQuoteSupplierItem: string;
    idPart: string;
    isError: boolean;
    removeQuoteItem: boolean;
    errorMessages: string[] | null;
  };
}

export interface LoadCart {
  type: typeof CartTypes.LOAD_CART;
  payload: {
    guidQuote: string;
  };
}

export interface ErrorCart {
  type: typeof CartTypes.ERROR_CART;
}
export interface ClearAllCart {
  type: typeof CartTypes.CLEAR_ALL_CART;
  payload: {
    guidQuote: string;
  };
}

export interface SetErrorsGeneralCart {
  type: typeof CartTypes.SET_ERRORS_GENERAL_CART;
  payload: {
    errorMessages: string[];
  };
}

export interface ResetReducerCart {
  type: typeof CartTypes.RESET_REDUCER_CART;
}

export type CartActionTypes =
  | AddCart
  | UpdateCart
  | SaveCart
  | RemoveCart
  | LoadCart
  | ResetReducerCart
  | AddingCart
  | UpdatingCart
  | RemovingCart
  | ErrorCart
  | ClearAllCart
  | SetErrorsGeneralCart;
